/* eslint-disable react/no-typos */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ClickableDiv from 'components/Common/ClickableDiv';
import Styles from './index.module.css';

export default function AdvertisingMethodButton({
  title,
  subTitle,
  src,
  selected,
  disabled,
  expanded,
  onClick,
  className,
  ...props
}) {
  return (
    <ClickableDiv
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        Styles.mainContainer,
        className,
        {
          [Styles.mainContainerExpanded]: expanded,
          [Styles.mainContainerSelected]: selected,
          [Styles.mainContainerDisabled]: disabled,
        },
      )}
      {...props}
    >
      <div
        className={classNames(
          Styles.headerContainer,
          {
            [Styles.headerContainerSelected]: selected,
          },
        )}
      >
        <div>{title}</div>
        <div>{subTitle}</div>
      </div>
      <img
        alt=""
        src={src}
        className={classNames(Styles.image, { [Styles.imageHidden]: !expanded })}
      />
      <div
        className={classNames(
          Styles.cardUnderlay, { [Styles.cardUnderlayDisabled]: disabled || selected },
        )}
      />
    </ClickableDiv>
  );
}

AdvertisingMethodButton.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  src: PropTypes.Object,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

AdvertisingMethodButton.defaultProps = {
  title: '',
  subTitle: '',
  src: '',
  selected: false,
  disabled: false,
  expanded: false,
  onClick: () => {},
  className: '',
};
